import * as React from "react";
import { SecondaryHeading, HeadingTitle } from "../../components";
import { renderMbnIcon } from "../EventCard/RenderMethods";
export class OutrightHeading extends React.PureComponent {
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(SecondaryHeading, { key: `subheading-${this.props.id}`, componentPrefix: this.props.componentPrefix },
                React.createElement(HeadingTitle, { name: this.props.name, eventsCount: "" }),
                this.props.mbnTag && renderMbnIcon(this.props.mbnTag)),
            this.props.children));
    }
}
//# sourceMappingURL=OutrightHeading.js.map